import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Remove Fill
 */

export default function RemoveFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M2 2.5H5V0.5C5 0.223858 5.22386 0 5.5 0H10.5C10.7761 0 11 0.223858 11 0.5V2.5H14C14.2761 2.5 14.5 2.72386 14.5 3C14.5 3.27614 14.2761 3.5 14 3.5H13V15.5C13 15.7761 12.7761 16 12.5 16H3.5C3.22386 16 3 15.7761 3 15.5V3.5L2 3.5C1.72386 3.5 1.5 3.27614 1.5 3C1.5 2.72386 1.72386 2.5 2 2.5ZM6 1V2.5H10V1H6ZM8.5 6C8.5 5.72386 8.27614 5.5 8 5.5C7.72386 5.5 7.5 5.72386 7.5 6L7.5 13C7.5 13.2761 7.72386 13.5 8 13.5C8.27614 13.5 8.5 13.2761 8.5 13L8.5 6ZM10 5.5C10.2761 5.5 10.5 5.72386 10.5 6V13C10.5 13.2761 10.2761 13.5 10 13.5C9.72386 13.5 9.5 13.2761 9.5 13L9.5 6C9.5 5.72386 9.72386 5.5 10 5.5ZM6.5 6C6.5 5.72386 6.27614 5.5 6 5.5C5.72386 5.5 5.5 5.72386 5.5 6L5.5 13C5.5 13.2761 5.72386 13.5 6 13.5C6.27614 13.5 6.5 13.2761 6.5 13L6.5 6Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
